import { render, staticRenderFns } from "./FavouriteAddedModal.vue?vue&type=template&id=767086cb"
import script from "./FavouriteAddedModal.vue?vue&type=script&lang=ts"
export * from "./FavouriteAddedModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports